import axios from "axios";

const api = axios.create({
  baseURL: "https://parcele-api.koin.com.br/",
  // baseURL: "http://localhost:8080",
});

export { api };
